<template>
  <main-layout>
    <template #body>
      <main-body>
        <div class="main-con">
          <table class="data-table">
            <thead>
              <tr>
                <th @click="sortOptionChange('rentalcompanyId','number')"  class="width-pixel-50">업체번호</th>
                <th @click="sortOptionChange('accountId','number')"  class="width-pixel-50">거래처번호</th>
                <th @click="sortOptionChange('accountName')" >거래처명</th>
                <th @click="sortOptionChange('contractFeeYn')" class="width-pixel-50">약정여부</th>
                <th @click="sortOptionChange('contractFee','number')" class="width-pixel-70">약정요금</th>
                <th @click="sortOptionChange('printerContractFee','number')"  class="width-pixel-70">프린터<br />약정요금</th>
                <th @click="sortOptionChange('billDay','number')" class="width-pixel-50">결제일</th>
                <th @click="sortOptionChange('calculationStartdate','number')" class="width-pixel-50">계산시작일</th>
                <th @click="sortOptionChange('taxSchDay','number')"  class="width-pixel-50">세금계산서<br />발행일</th>
                <th @click="sortOptionChange('statementIssueDay','number')"  class="width-pixel-50">거래명세표<br />발행일</th>
                <th @click="sortOptionChange('useYn')" class="width-pixel-50">계약상태</th>
                <th @click="sortOptionChange('bizType')" class="width-pixel-50">납부자유형</th>
                <th @click="sortOptionChange('deleteYn')" class="width-pixel-50">삭제여부</th>
                <th @click="sortOptionChange('regDatetime')" class="width-pixel-100">등록일시</th>
                <th @click="sortOptionChange('uptDatetime')" class="width-pixel-100">변경일시</th>
                <th @click="sortOptionChange('registerName')">등록자명</th>
                <th @click="sortOptionChange('unpaidRequestYn')" class="width-pixel-50">미납금액<br />재출금여부</th>
                <th @click="sortOptionChange('autoUseYn')" class="width-pixel-50">자동화<br /> 매출</th>
                <th @click="sortOptionChange('autoUseCmsYn')" class="width-pixel-50">자동화<br />CMS</th>
                <th @click="sortOptionChange('autoUseTaxYn')" class="width-pixel-50">자동화 <br />세금계산서</th>
                <th @click="sortOptionChange('autoUseStatementYn')" class="width-pixel-50">자동화 <br />거래명세표</th>
                  <th @click="sortOptionChange('autoUptDateTime')" class="width-pixel-100">자동화 <br />변경일시</th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in tableBodyData" :key="index">
              <td class="table-text-center">{{ item.rentalcompanyId }}</td>
              <td class="table-text-center">{{ item.accountId }}</td>
              <td :title="item.accountName" class="column-size-short">{{ item.accountName }}</td>
              <td class="table-text-center">{{ item.contractFeeYn }}</td>
              <td class="column-right-align">{{ numberFormat(item.contractFee) }}</td>
              <td class="column-right-align">{{ numberFormat(item.printerContractFee) }}</td>
              <td>{{ item.billDay }}</td>
              <td>{{ item.calculationStartdate }}</td>
              <td>{{ item.taxSchDay }}</td>
              <td>{{ item.statementIssueDay }}</td>
              <td class="table-text-center">{{ item.useYn }}</td>
              <td class="table-text-center">{{ item.bizType }}</td>
              <td class="table-text-center">{{ item.deleteYn }}</td>
              <td :title="dateFormatChange(item.regDatetime)">{{ dateFormatChange(item.regDatetime) }}</td>
              <td :title="dateFormatChange(item.uptDatetime)">{{ dateFormatChange(item.uptDatetime) }}</td>
              <td :title="item.registerName" class="column-size-short">{{ registerSystemFlag(item.registerName) }}</td>
              <td class="table-text-center">{{ item.unpaidRequestYn }}</td>
              <td class="table-text-center">{{ item.autoUseYn }}</td>
              <td class="table-text-center">{{ item.autoUseCmsYn }}</td>
              <td class="table-text-center">{{ item.autoUseTaxYn }}</td>
              <td class="table-text-center">{{ item.autoUseStatementYn }}</td>
                <td :title="dateFormatChange(item.regDatetime)">{{ dateFormatChange(item.autoUptDatetime )}}</td>
            </tr>
<!--            거래처 관리는 추가로드 버튼 안넣기로 했습니다. 차후에 사용할 수 있을것같아서 주석 처리했습니다.-->
<!--            <v-btn-->
<!--                :color="disableButton ? 'primary':'#cccccc'"-->
<!--                dark-->
<!--                large-->
<!--                @click="plusLoadButtonClick"-->
<!--                class="add-load-button"-->
<!--            >-->
<!--              추가로드-->
<!--            </v-btn>-->
            </tbody>
          </table>
        </div>

      </main-body>
    </template>
  </main-layout>
</template>

<script>
import MainBody from "@/components/common/layout/MainBody";
import MainLayout from "@/components/common/layout/MainLayout";
import {DateTime} from "luxon";

export default {
  name: "NoLibraryBagicTable",
  components: {
    MainLayout,
    MainBody,
  },
  data() {
    return {
      sortOption: {
        sortName: null,
        sortOrder: 1,
      },
    }
  },
  props :{
    tableBodyData:{
      type:Array
    },
      disableButton:{
          type:Boolean,
          default:false
      },
  },
  methods: {
      /***
       * registerName에 mig가 포함시 System으로 표기
       */
      registerSystemFlag(registerName) {
          if(!registerName) return ''
          return registerName.includes('mig') ? 'SYSTEM' : registerName;
      },

      /**
       * type이 date 인 cell은 Utc+9로 변경합니다
       * @param row
       * @returns {*}
       */
      dateFormatChange(date){
          if (!date) return undefined
          return DateTime.fromISO(DateTime.fromISO(date, {zone: 'utc'}).toISO()).toFormat("yyyy-MM-dd HH:mm")
      },

      /**
       * 돈과 연관되있는 데이터는 3번째 자리에서 ,를 찍어줍니다
       *
       * @param number
       * @returns {string}
       */
      numberFormat(number){
          if(!number) return '0'
          return number.toLocaleString()
      },
      // /**
      //  * 추가로드 버튼을 클릭시 동작합니다.
      //  */
      // plusLoadButtonClick() {
      //     if(!this.disableButton) return //데이터가 없을때 추가로드 비활성화 합니다.
      //     this.$emit('page-number-plus');
      // },

      /**
       * header를 누를때 동작합니다.
       * 먼저 sortOption을 세팅하고 그에 맞게 sorting 해줍니다.
       * 숫자랑 문자 다 가능합니다.
       * 데이터가 undefined 일 경우도 있어서 애초에 칼럼에 타입을 인자로 받습니다.
       *
       */
      sortOptionChange(e,type) {
          this.setSortOption(e);
          this.$emit("sort-option-change",e,this.sortOption,type)
      },

    initSort(){
      this.sortOption = {
        sortName: null,
        sortOrder: 1,
      }
    },
    setSortOption(e) {
      if (e === this.sortOption.sortName){
        this.sortOption.sortOrder *= -1
      } else {
        this.sortOption = {
          sortName: e,
          sortOrder: 1,

        }
      }
    },


  }
}
</script>

<style scoped>

>>> input[type=checkbox] {
  position: absolute;
}

.main-con{
  height: 100%;
  overflow-y: auto;
}
.main-con .data-table{
    table-layout: fixed;
    border-spacing: 0;
    width: 120%;
    overflow-x: auto;
}
.main-con .data-table thead{
  position: sticky;
  top: 0;
  background: #ddd;
}
.main-con .data-table thead tr th {
    font-size: 11px;
    padding-right: 8px;
}

.main-con .data-table tbody td{
    text-align: left;
    border: 1px solid #ccc;
    font-size: 11px;
    padding: 0.15rem;
}

.main-con .data-table tbody tr:nth-child(even){
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover{
  background: #ddd;
}

.column-size-short{
  text-overflow:ellipsis;
  overflow:hidden;
  white-space:nowrap;
}
.width-pixel-50{
    width: 50px !important;
}
.width-pixel-70{
    width: 70px !important;
}
.width-pixel-100{
    width: 100px !important;
}
.column-right-align{
    text-align: right !important;
}
.table-text-center{
    text-align: center !important;
}
</style>
